import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import QRComponent from './QRComponent';
import axiosInstance from '../../utils/axiosInstance';

import {
  CityFilterAction,
  buildingFilterAction,
  editTrainingRoomForm,
  RoomMaList,
  TowerFilterAction,
  FloorFilterAction,
} from '../../Redux/action/roomTraingAction';

import Select from 'react-select';
import { dataUser } from '../Helpers/util';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwInput from '../Common/FormComponent/SwInput';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwSwitchButtons from '../Common/SwSwitchButtons/SwSwitchButtons';
import SwButton from '../Common/SwButtons/SwButtons';
import SwKpiGroup from '../Common/SwKPI/SwKpiGroup';
import SwKpi from '../Common/SwKPI/SwKPI';
import AntDTable from '../Common/AntDTable/AntDTable';
import AntDUpload from '../Common/AntDUpload/AntDUpload';

var QRCode = require('qrcode.react');

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const cityOption = [];

var buildingOption = [];
var towerOption = [];
var FloorOption = [];

class RoomTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataAdd: false,
      hidVal: null,
      company_id: UserObj.company_id,
      baseUrlCommon:
        'https://smartworks-web-production.s3-ap-southeast-1.amazonaws.com/mrcr_room_images_thumb/',
      itemsEdit: {},
      SetRoomStatus: '',
      RoomUpperPannel: [],
      RoomTrainingList: [],
      FloorApiData: [],
      qrUrls: 0,
      seat: '',
      setFlagCity: false,
      buildingOptions: [], // For the building dropdown
      floorOptions: [], // For the floor dropdown
      selectedBuilding: null, // Selected building object
      selectedFloor: null, // Selected floor object
      selectedBuildingId: null, // Selected building ID
      selectedFloorId: null, // Selected floor ID
      trainingRoomList: [],
      cityApiData: [],
      buildingApiData: [],
      TowerApiData: [],
      meetingroom_code: '',
      city: '',
      room_image: null,
      building_id: '',
      floor_id: '',
      tower_id: '',
      room_type: '',
      type: '',
      isActive: '',
      no_of_seats: '',
      time_slot: '',
      bookingId: '',
      cityId: '',
      buildingId: '',
      floorId: '',
      cityOptions: [],
      buildingOptions: [],
      floorOptions: [],
      name: '',

      name: '',
      timeSlot: '',
      pricePerSlot: '',

      capacity: '',

      meeting_alltime: '',
      isAvailableAllTime: false,
      openTime: '',
      closeTime: '',
      items: {},
      loader: false,
      currentPage: 1,
      pageSize: 25,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
    };
  }

  changeforward = () => {
    this.setState({
      setIndex: this.state.setIndex + 1,
      loader: true,
    });
    var itemIndex = this.state.RoomTrainingList[this.state.setIndex + 1];
    this.setState({
      itemsEdit: itemIndex,
      meetingroom_code: itemIndex.meetingroom_code,
      floor_id: itemIndex.floor_id,
      room_type: itemIndex.room_type,
      status: itemIndex.status,
      no_of_seats: itemIndex.no_of_seats,
      time_slot: itemIndex.time_slot,
      price_per_slot: itemIndex.price_per_slot,
      meeting_alltime: itemIndex.meeting_alltime,
      meeting_opentime: itemIndex.meeting_opentime,
      meeting_closetime: itemIndex.meeting_closetime,
      meetingroom_id: itemIndex.meetingroom_id,
    });
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 1000);
  };

  changebackformward = () => {
    this.setState({
      setIndex: this.state.setIndex - 1,
      loader: true,
    });
    var itemIndex = this.state.RoomTrainingList[this.state.setIndex - 1];
    this.setState({
      itemsEdit: itemIndex,
      meetingroom_code: itemIndex.meetingroom_code,
      floor_id: itemIndex.floor_id,
      room_type: itemIndex.room_type,
      status: itemIndex.status,
      no_of_seats: itemIndex.no_of_seats,
      time_slot: itemIndex.time_slot,
      price_per_slot: itemIndex.price_per_slot,
      meeting_alltime: itemIndex.meeting_alltime,
      meeting_opentime: itemIndex.meeting_opentime,
      meeting_closetime: itemIndex.meeting_closetime,
      meetingroom_id: itemIndex.meetingroom_id,
    });
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 1000);
  };

  togglecheked = e => {
    let val = false;
    if (e.target.checked) {
      val = true;
    } else {
      val = false;
    }
    this.setState({
      [e.target.name]: val,
      hidVal: val,
    });
  };

  EditSubmit = (e) => {
    e.preventDefault();

    if (this.state?.name === "") {
      toast.success("Please Enter Room Name");
      return;
    }

    const allowedKeys = [
      "name", "isActive", "capacity", "timeSlot", "pricePerSlot", "isAvailableAllTime",
      "openTime", "closeTime", "propertyId", "floorId", "isPublic", "type",
      "added_by", "booking_slot_timelimit", "thumbnailImage" // ✅ Image field
    ];

    let param = {};
    const { oldState, nfile, image } = this.state;

    allowedKeys.forEach((key) => {
      if (oldState[key] !== this.state[key]) {
        param[key] = this.state[key];
      }
    });

    // ✅ Always send image, whether updated or not
    param.thumbnailImage = nfile || image;

    if (Object.keys(param).length > 0) {
      const bookingId = oldState.bookingId;
      this.props.editTrainingRoomForm(bookingId, param);
      this.setState({ dataAdd: true });
    }
  };

  uploadDocument = async (file) => {
    if (!file) return;

    this.setState({ fileName: file.name, uploading: true });

    try {
      const sanitizedFileName = encodeURIComponent(file.name.trim());
      const attachments = {
        bucket: "meeting-room-api",
        key: `resources/${sanitizedFileName}`,
      };

      // Step 1: Get the signed upload URL
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}fileupload`,
        attachments
      );

      const uploadUrl = data?.uploadUrl;
      if (!uploadUrl) throw new Error("Failed to get upload URL.");

      // Step 2: Upload the file to S3
      await axios.put(uploadUrl, file, {
        headers: { "Content-Type": file.type || "binary/octet-stream" },
      });

      // Step 3: Extract only the base URL (trim query parameters)
      const trimmedUrl = uploadUrl.split("?")[0];

      // Step 4: Update state with the new uploaded image
      this.setState({ nfile: trimmedUrl });


    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      this.setState({ uploading: false });
    }
  };



  onChangeValue = event => {
    this.setState({ isActive: event.target.value === 'true' });
  };

  EditMemeberHandler = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };





  qrCodeUrl = (qrUrl, setaNum) => {
    let setQr = qrUrl;
    this.setState({
      qrUrls: setQr,
      seat: setaNum,
    });
  };

  downloadQR = () => {
    const canvas = document.getElementById('123456');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'QR.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  componentWillReceiveProps(props) {

    if (props.FloorReducer && props.FloorReducer.length != 0) {
      this.setState({
        FloorApiData: props.FloorReducer,
        setFlagCity: true,
      });
    }
    if (
      this.state.dataAdd == true &&
      this.props.roomTraingReducer.EditRoomResults &&
      this.props.roomTraingReducer.EditRoomResults.data &&
      this.props.roomTraingReducer.EditRoomResults.data.status == 200
    ) {
      {
        this.setState({
          dataAdd: false,
        });
        this.setState({ errorLogin: true });
        let newCompanyId = JSON.parse(localStorage.getItem('headData'));
        const param = {
          pgno: this.props.pgNumber,
          num_row: this.props.pgRowNumber,
          includes: "KPI",
          clientId: [newCompanyId.organizationId],
          reqFrom: "cspoc",
          type: [
            "Meeting Room",
            "Conference Room",
            "Training Room",
            "AV Lounge"
          ],
          propertyId: this.props.propertyId
        };

        this.props.RoomMaList(param);
      }
    }

    if (
      props.roomTraingReducer &&
      props.roomTraingReducer.RoomTrainingData &&
      props.roomTraingReducer.RoomTrainingData.status == 200
    ) {
      this.setState({
        RoomUpperPannel:
          props.roomTraingReducer &&
          props.roomTraingReducer.RoomTrainingData &&
          props.roomTraingReducer.RoomTrainingData.data &&
          props.roomTraingReducer.RoomTrainingData.data.data,

        SetRoomStatus:
          props.roomTraingReducer &&
          props.roomTraingReducer.RoomTrainingData &&
          props.roomTraingReducer.RoomTrainingData.status,

        RoomTrainingList:
          props.roomTraingReducer &&
          props.roomTraingReducer.RoomTrainingData &&
          props.roomTraingReducer.RoomTrainingData.data &&
          props.roomTraingReducer.RoomTrainingData.data.data &&
          props.roomTraingReducer.RoomTrainingData.data.data.list,
      });
    }
    if (props.TowerReducer && props.TowerReducer.length != 0) {
      this.setState({
        TowerApiData: props.TowerReducer,
        setFlagCity: true,
      });
    }
    if (props.CityNameReducer && props.CityNameReducer.length != 0) {
      this.setState({
        cityApiData: props.CityNameReducer,
      });
    }
    if (props.BuildingReducer && props.BuildingReducer.length != 0) {
      this.setState({
        buildingApiData: props.BuildingReducer,
        setFlagCity: true,
      });
    }
  }

  sendId = (items, i) => {
    this.setOldState(items);

    this.setState(
      {
        name: items.name || "",
        timeSlot: items.timeSlot || "",
        pricePerSlot: items.pricePerSlot || "",
        type: items.type || "",
        capacity: items.capacity || "",
        isActive: items.isActive ?? false,
        isAvailableAllTime: items.isAvailableAllTime ?? false,
        openTime: items.openTime || "",
        closeTime: items.closeTime || "",
        bookingId: items._id || "",
        floorName: items.floorDetails?.name || "",
        cityId: items.propertyDetails?.name || "",
        buildingId: items.propertyDetails?.id || "",
        buildingName: items.propertyDetails?.name || "",
        floorId: items.floorDetails?.id || "",
        setIndex: i,
        image: items.thumbnailImage || "", // ✅ Set existing image
        nfile: "" // ✅ Reset uploaded image state
      },
      () => {
        this.fetchBuildingData(items.propertyDetails?.id, items.floorDetails?.id);
      }
    );
  };
  setOldState = items => {

    this.setState({
      oldState: {
        name: items.name,
        timeSlot: items.timeSlot,
        pricePerSlot: items.pricePerSlot,
        type: items.type,
        capacity: items.capacity,
        isActive: items.isActive,
        isAvailableAllTime: items.isAvailableAllTime,
        openTime: items.openTime,
        closeTime: items.closeTime,
        bookingId: items._id,
        floorName: items.floorDetails.name,
        cityId: items.propertyDetails.name,
        propertyId: items.propertyDetails.id,
        buildingName: items.propertyDetails.name,
        floorId: items.floorDetails.id,
      },
    });
  };

  btnClick() {
    mixpanel.track('Reports MR page view', {
      PageName: 'MR Inventoryt',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'MR Inventory',
    });
  }

  componentDidMount() {
    const { isEditMode, editRoomData } = this.props; // Props passed to determine if
    // editing and the room data
    if (isEditMode && editRoomData) {
      // Prepopulate with existing room data
      const { buildingId, floorId } = editRoomData;
      this.fetchBuildingData(buildingId, floorId);
    } else {
      // Default fetch for adding a room
      this.fetchBuildingData();
    }
    // this.SetCityValue();
    this.btnClick();
  }

  /*1---setCity---*/
  SetCityValue = city => {
    const formData = new FormData();
    formData.append('company_id', this.state.company_id);
    this.props.CityFilterAction(formData);
  };
  /*1---setCity---*/
  /*2---getCityDAta---*/
  CityNameMethod = city => {
    this.setState({ city: city.value });
    let params = {
      company_id: this.state.company_id,
      cityid: city.value,
    };
    this.props.buildingFilterAction(params);
  };
  /*2---getCityDAta---*/
  /*3---Building---*/
  buildingNameMethod = building => {
    this.setState({ building_id: building.value });
    // this.setState({ building_id: building.value, refreshBuilding:building });
    let params = {
      company_id: this.state.company_id,
      buildingid: building.value,
    };
    this.props.FloorFilterAction(params);
    this.props.TowerFilterAction(params);
  };
  /*3---Building---*/
  /*--tower--*/
  TowerNameMethod = building => {
    this.setState({ tower_id: building.value });
    let parSetv = {
      buildingid: this.state.building_id,
      tower_id: building.value,
      company_id: this.state.company_id,
    };
    this.props.FloorFilterAction(parSetv);
  };

  fetchBuildingData = async (
    buildingId,
    floorId,
    selectedBuildingId = null,
    selectedFloorId = null,
  ) => {
    let organizationId = JSON.parse(localStorage.getItem('headData'));

    try {
      const requestData = {
        ids: [organizationId.organizationId], // List of organization IDs you want to query
        includes: ['properties'], // Any other related properties (e.g., cities)
      };

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}core/organizations/all`,
        requestData,
      );

      // Extract building options
      const buildingOptions = response?.data?.data[0]?.properties?.map(
        property => ({
          value: property.id,
          label: property.name, // Building name
          properties: property, // Attach the property object to later fetch floors
        }),
      );

      // Prepopulate selectedBuilding and floorOptions if selectedBuildingId is provided
      let selectedBuilding = null;
      let floorOptions = [];
      let selectedFloor = null;

      if (buildingId) {
        selectedBuilding = buildingOptions.find(
          building => building.value === buildingId,
        );

        if (selectedBuilding) {
          floorOptions =
            selectedBuilding.properties?.floors?.map(floor => ({
              value: floor.id,
              label: floor.name,
            })) || [];

          if (floorId) {
            selectedFloor = floorOptions.find(floor => floor.value === floorId);
          }
        }
      }

      this.setState({
        buildingOptions,
        floorOptions,
        selectedBuilding,
        selectedFloor,
      });
    } catch (error) {
      console.error('Error fetching buildings:', error);
    }
  };

  handleBuildingChange = selectedBuilding => {
    const building = this.state.buildingOptions.find(
      b => b.value === selectedBuilding.value,
    );

    if (building) {
      const floorOptions =
        building.properties?.floors?.map(floor => ({
          value: floor.id,
          label: floor.name,
        })) || [];

      this.setState({
        selectedBuilding,
        selectedBuildingId: selectedBuilding.value,
        propertyId: selectedBuilding.value,
        buildingName: selectedBuilding.label,
        floorOptions,
        selectedFloor: null, // Reset the floor when building changes
      });
    }
  };

  handleFloorChange = selectedFloor => {
    this.setState({
      selectedFloor,
      selectedFloorId: selectedFloor ? selectedFloor.value : null,
      floorName: selectedFloor.label,
      floorId: selectedFloor.value,
    });
  };

  /*--tower-End--*/
  FloorNameMethod = building => {
    this.setState({ floor_id: building.value });
  };

  render() {
    const sharfeData = this.props.propertyId

    const RoomManagement = this.state.userRole?.find(
      element => element.service_id == '4',
    );

    const sharfe = this.props.roomTraingReducer.RoomTrainingData;

    //--City--///

    if (this.state.cityApiData !== 0) {
      // cityFname ={};
      this.state.cityApiData &&
        this.state.cityApiData.map((items, i) => {
          cityOption.push({ value: items.city_id, label: items.city_name });
        });
    }
    //--City---///
    //--Building---///

    if (this.state.buildingApiData !== 0) {
      buildingOption = [];
      this.state.buildingApiData &&
        this.state.buildingApiData.map((items, i) => {
          buildingOption.push({
            value: items.building_id,
            label: items.building_name,
          });
        });
    }
    //--Building--///
    //--Tower---///

    if (this.state.TowerApiData !== 0) {
      towerOption = [];
      this.state.TowerApiData &&
        this.state.TowerApiData.map((items, i) => {
          towerOption.push({
            value: items.tower_id,
            label: items.tower_name,
          });
        });
    }
    //--Tower---///

    if (this.state.FloorApiData !== 0) {
      FloorOption = [];
      this.state.FloorApiData &&
        this.state.FloorApiData.map((items, i) => {
          FloorOption.push({
            value: items.floor_id,
            label: items.floor_name,
          });
        });
    }
    const typeOptions = [
      { value: "Meeting Room", label: "Meeting" },
      { value: "Conference Room", label: "Conference" },
      { value: "Training Room", label: "Training" },
      { value: "AV Lounge", label: "Lounge" },
    ];
    const timeOptions = [
      { value: "01:00:00", label: "1:00" },
      { value: "01:30:00", label: "1:30" },
      { value: "02:00:00", label: "2:00" },
      { value: "02:30:00", label: "2:30" },
      { value: "03:00:00", label: "3:00" },
      { value: "03:30:00", label: "3:30" },
      { value: "04:00:00", label: "4:00" },
      { value: "04:30:00", label: "4:30" },
      { value: "05:00:00", label: "5:00" },
      { value: "05:30:00", label: "5:30" },
      { value: "06:00:00", label: "6:00" },
      { value: "06:30:00", label: "6:30" },
      { value: "07:00:00", label: "7:00" },
      { value: "07:30:00", label: "7:30" },
      { value: "08:00:00", label: "8:00" },
      { value: "08:30:00", label: "8:30" },
      { value: "09:00:00", label: "9:00" },
      { value: "09:30:00", label: "9:30" },
      { value: "10:00:00", label: "10:00" },
      { value: "10:30:00", label: "10:30" },
      { value: "11:00:00", label: "11:00" },
      { value: "11:30:00", label: "11:30" },
      { value: "12:00:00", label: "12:00" },
      { value: "12:30:00", label: "12:30" },
      { value: "13:00:00", label: "13:00" },
      { value: "13:30:00", label: "13:30" },
      { value: "14:00:00", label: "14:00" },
      { value: "14:30:00", label: "14:30" },
      { value: "15:00:00", label: "15:00" },
      { value: "15:30:00", label: "15:30" },
      { value: "16:00:00", label: "16:00" },
      { value: "16:30:00", label: "16:30" },
      { value: "17:00:00", label: "17:00" },
      { value: "17:30:00", label: "17:30" },
      { value: "18:00:00", label: "18:00" },
      { value: "18:30:00", label: "18:30" },
      { value: "19:00:00", label: "19:00" },
      { value: "19:30:00", label: "19:30" },
      { value: "20:00:00", label: "20:00" },
      { value: "20:30:00", label: "20:30" },
      { value: "21:00:00", label: "21:00" },
      { value: "21:30:00", label: "21:30" },
      { value: "22:00:00", label: "22:00" },
      { value: "22:30:00", label: "22:30" },
      { value: "23:00:00", label: "23:00" },
      { value: "23:30:00", label: "23:30" },
      { value: "24:00:00", label: "24:00" },
    ];
    const columns = [
      {
        title: "Room Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Location",
        key: "location",
        render: (_, record) => record?.propertyDetails?.name,
      },
      {
        title: "Status",
        key: "status",
        render: (_, record) =>
          record.isActive ? (
            <span className="text-success">Active</span>
          ) : (
            <span className="SwTextDanger">Inactive</span>
          ),
      },
      {
        title: "Room Type",
        key: "type",
        render: (_, record) => {
          if (record.type === "Meeting Room") return "Meeting";
          if (record.type === "Conference Room") return "Conference";
          if (record.type === "Training Room") return "Training";
          return "Lounge";
        },
      },
      {
        title: "Created Date",
        key: "createdAt",
        render: (_, record) =>
          moment(record.createdAt).format("DD MMM YYYY"),
      },
      {
        title: "Created By",
        dataIndex: "createdBy",
        key: "createdBy",
      },
      {
        title: "Price Per Slot",
        dataIndex: "pricePerSlot",
        key: "pricePerSlot",
      },
      {
        title: "Edit",
        key: "edit",
        render: (_, record, index) =>
          RoomManagement?.role_for_write === "1" && (
            <span
              className='SwSortableTh'
              onClick={() => {
                this.sendId(record, index);
                this.setState({ showEditDrawer: true });
              }}
            >
              <i className="fa fa-pencil" />
            </span>
          ),
      },
    ];
    return (
      <>
        <SwOffCanvas
          show={this.state.showEditDrawer}
          onClose={() => this.setState({ showEditDrawer: false })}
          title="Edit Room Details"
          placement="end"
          className="sw-default-offcanvas"
          footer={
            <div className="d-flex justify-content-end">
              <SwButton
                size='sm'
                onClick={this.EditSubmit}
              >
                Update
              </SwButton>
            </div>
          }
        >
          <div className={this.state.loader ? "loader" : "loader disable"} />
          <from>
            <div className="row">
              <div className="row mb-4">
                <div className="col-md-8">
  <div className="editImg">
    <label className="setimgArea setEdit">
      <input
        type="file"
        className="Uploadfilebtn parset"
        onChange={(e) => this.uploadDocument(e.target.files[0])}
      />
      <span>+</span> Add Image
    </label>
    {this.state.nfile ? (
      <img src={this.state.nfile} className="sp1" alt="New Upload" />
    ) : (
      this.state.image && <img src={this.state.image} className="sp2" alt="Existing Image" />
    )}
  </div>

                </div>
              </div>

              <div className="col-md-6 col-xs-12 col-sm-6">
                
                  <div className='SwFormGroup'>
                    <label className='SwFormLabel'>
                      Room Name <span className='Required'>*</span>
                    </label>
                    <SwInput
                      type="text"
                      name="name"
                      value={this.state.name}
                      onChange={this.EditMemeberHandler}
                      placeholder='Enter Room Name'
                    />
                  </div>
                
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Building Name <span className='Required'>*</span>
                  </label>
                  <SwSelect
                    onChange={this.handleBuildingChange}
                    options={this.state.buildingOptions}
                    value={this.state.selectedBuilding || null}
                    placeholder="Select Building name"
                    isClearable={false}
                  />
                </div>
              </div>
              <div className="col-md-6 ">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Floor Name <span className='Required'>*</span>
                  </label>
                  <SwSelect
                    onChange={this.handleFloorChange}
                    options={this.state.floorOptions}
                    value={this.state.selectedFloor || null}
                    placeholder="Select Floor name"
                    isClearable={false}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="SwFormGroup">
                  <label className='SwFormLabel'>Booking Slot Minutes <span className='Required'>*</span></label>
                  <SwInput
                    type="text"
                    name="timeSlot"
                    value={this.state.timeSlot}
                    onChange={this.EditMemeberHandler}
                    placeholder='Enter Booking Slot Minutes'
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="SwFormGroup">
                  <label className='SwFormLabel'>Price Per Slot <span className='Required'>*</span></label>
                  <SwInput
                    type="text"
                    name="pricePerSlot"
                    value={this.state.pricePerSlot}
                    onChange={this.EditMemeberHandler}
                    placeholder='Enter Price Per Slot'
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 ">
                <div className="SwFormGroup">
                  <label className='SwFormLabel'>Room Type</label>
                  <SwSelect
                    name="type"
                    options={typeOptions}
                    placeholder="Select Type"
                    value={typeOptions.find(
                      (item) => item.value === this.state.type
                    )}
                    onChange={(selectedOption) => {
                      this.EditMemeberHandler({
                        target: {
                          name: "type",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      });
                    }}
                    isClearable={false}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="SwFormLabel">
                  <label className='SwFormLabel'>Seating Capacity<span className='Required'>*</span></label>
                  <SwInput
                    type="text"
                    name="capacity"
                    value={this.state.capacity}
                    onChange={this.EditMemeberHandler}
                    placeholder='Enter Seating Capacity'
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 ">
                <div className="SwFormGroup">
                  <label className='SwFormLabel'>
                    Status <span className='Required'>*</span>
                  </label>
                  <div onChange={this.onChangeValue}>
                    <SwRadio
                      id="status-actives"
                      name="statuss"
                      value="true"
                      label="Active"
                      checked={this.state.isActive === true}
                      onChange={this.onChangeValue}
                    />
                    <SwRadio
                      id="status-inactives"
                      name="statuss"
                      value="false"
                      label="Inactive"
                      checked={this.state.isActive === false}
                      onChange={this.onChangeValue}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormLabel">
                  <label>24 x 7 Booking Allowance <span className='Required'>*</span></label>
                  
                  <SwSwitchButtons
                    id="isAvailableAllTime"
                    checked={this.state.isAvailableAllTime}
                    onChange={(e) =>
                      this.setState({
                        isAvailableAllTime: e.target.checked,
                      })
                    }
                    size="lg"
                    className="mt-1"
                  />
                  <br />
                  <span className="smText">
                    Facilitate 24 x 7 availability of meeting rooms.
                  </span>
                </div>
              </div>
            </div>
            <div
              className={
                this.state.isAvailableAllTime === true
                  ? 'row d-none'
                  : 'row '
              }
            >
              <div className="col-md-6 col-xl-6 col-lg-6">
                <div className="editTextMember setedit full">
                  <label className='SwFormLabel'>Booking Start Time <span className='Required'>*</span></label>
                  <SwSelect
                    options={timeOptions}
                    placeholder="Select time"
                    value={timeOptions.find(
                      (opt) => opt.value === this.state.openTime
                    )}
                    onChange={(selected) => {
                      this.setState({
                        openTime: selected ? selected.value : "",
                      });
                    }}
                    isClearable={false}
                  />
                </div>
              </div>

              <div className="col-md-6 col-xl-6 col-lg-6">
                <div className="editTextMember setedit full">
                  <label className='SwFormLabel'>Booking End Time <span className='Required'>*</span></label>
                  <SwSelect
                    options={timeOptions}
                    placeholder="Select close time"
                    value={timeOptions.find(
                      (opt) => opt.value === this.state.closeTime
                    )}
                    onChange={(selected) => {
                      this.setState({
                        closeTime: selected ? selected.value : "",
                      });
                    }}
                    isClearable={false}
                  />

                </div>
              </div>
            </div>
            <div className="mardgbtn" />
          </from>
        </SwOffCanvas>

        <div className=" modal fade qrModel" id="myModal">
          <div className="modal-dialog ">
            <div className="modal-content ">
              <div className="formTitle">
                Print Qr Code
                <button
                  type="button"
                  className="relateDox close"
                  data-dismiss="modal"
                >
                  x
                </button>
              </div>
              <div className="modal-body">
                <div className="qrScannerMain">
                  <div className="row">
                    <div className="col-md-12 col-xl-6 col-lg-6">
                      <QRComponent
                        ref={el => (this.componentRef = el)}
                        src={`https://chart.googleapis.com/chart?cht=qr&chl=${this.state.qrUrls
                          }&chs=200x200`}
                        meetingId={this.state.qrUrls}
                      />
                    </div>
                    <div className="col-md-12 col-xl-6 col-lg-6">
                      <p>Seat Number : {this.state.seat}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="buttonqr float-right">
                        <a
                          onClick={() => this.downloadQR()}
                          className="btn btn-light outlinebutton"
                        >
                          Download QR
                        </a>
                        <ReactToPrint
                          trigger={() => {
                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                            // to the root node of the returned component as it will be overwritten.
                            return (
                              <button className="btn btn-success">
                                Print QR
                              </button>
                            );
                          }}
                          content={() => this.componentRef}
                        />{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <SwKpiGroup>
              <SwKpi
                label='Total Rooms'
                value={this.state.RoomUpperPannel.total}
              />
              <SwKpi
                label='Meeting Rooms'
                value={this.state.RoomUpperPannel['Meeting Room']}
              />
              <SwKpi
                label='Training Rooms'
                value={this.state.RoomUpperPannel['Training Room']}
              />
              <SwKpi
                label='Lounge Rooms'
                value={this.state.RoomUpperPannel['AV Lounge']}
              />
              <SwKpi
                label='Conference Rooms'
                value={this.state.RoomUpperPannel['Conference Room']}
              />
              <SwKpi
                label='Active Rooms'
                value={this.state.RoomUpperPannel.Active}
              />
              <SwKpi
                label='In-active Rooms'
                value={this.state.RoomUpperPannel.Inactive}
              />

            </SwKpiGroup>
          </div>
        </div>
        <div className="commonTable">
          <AntDTable
            columns={columns}
            dataSource={this.state.RoomTrainingList || []}
            rowKey="_id"
            pagination={true}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            totalRecords={this.state.RoomUpperPannel?.total}
            onPageChange={(page, pageSize) => {

              this.setState({
                currentPage: page,
                pageSize: pageSize,
              });

              const newCompanyId = JSON.parse(localStorage.getItem("headData"));

              const param = {
                pageOffset: page,
                pageSize: pageSize,
                includes: "KPI",
                propertyId: this.props.propertyId,
                reqFrom: "cspoc",
                clientId: [newCompanyId.organizationId],
                type: [
                  "Meeting Room",
                  "Conference Room",
                  "Training Room",
                  "AV Lounge",
                ],
              };

              this.props.RoomMaList(param);
            }}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  roomTraingReducer: state.roomTraingReducer,
  CityNameReducer: state.roomTraingReducer.TrainingRoomCityData,
  BuildingReducer: state.roomTraingReducer.TrainingRoomBuilding,
  AddRoomResults: state.roomTraingReducer.AddRoomResults,
  TowerReducer: state.roomTraingReducer.TrainingRoomTower,
  FloorReducer: state.roomTraingReducer.TrainingRoomFloor,
});

const mapActionsToProps = {
  CityFilterAction,
  buildingFilterAction,
  editTrainingRoomForm,
  RoomMaList,
  TowerFilterAction,
  FloorFilterAction,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(RoomTable);
